import { BASE_URL } from '../constants'

const useReportError = () => {
  const reportError = async errors => {
    let response
    try {
      response = await fetch(`${BASE_URL}/Marketing/ReportError`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          value: 'Error report marketing website :: ' + JSON.stringify(errors),
        }),
      })
    } catch (error) {
      response = error
    }
    return response
  }

  return { reportError }
}

export default useReportError
